import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch } from 'react-redux';

import {
  applyCurrentFilter,
  resetFilters,
  setCoursePauseFilterModalState,
} from 'features/courseResume';
import styles from './FilterDrawerHeader.module.scss';

function FilterDrawerHeader() {
  const dispatch = useDispatch();

  const handleModalClose = useCallback(() => {
    dispatch(setCoursePauseFilterModalState(false));
  }, [dispatch]);

  const handleResetFilter = useCallback(() => {
    dispatch(resetFilters());
  }, [dispatch]);

  const handleApplyFilter = useCallback(() => {
    dispatch(applyCurrentFilter());
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Icon
          name="arrow-left"
          className="m-r-xxs cursor"
          onClick={handleModalClose}
        />
        Filters
      </div>
      <div>
        <Tappable
          noHighlight
          onClick={handleResetFilter}
          className="primary m-r-xs h5 bold"
        >
          Reset Filters
        </Tappable>
        <Tappable
          onClick={handleApplyFilter}
          className="btn btn-primary btn-small btn-long bold"
        >
          Apply
        </Tappable>
      </div>
    </div>
  );
}

export default FilterDrawerHeader;
